import React from 'react';
import { Alert, Card, Col, Row } from 'react-bootstrap';

export default function AccessLimitations() {
  return (
    <section className="mt-5" aria-labelledby="access-limitations-heading">
      <h2 id="access-limitations-heading" className="h3">
        This is a mock-order drill
      </h2>
      <Alert variant="warning">
        <strong>Havn tingrett, Direktoratet for innbyggertillit, Havn nøkkeldepot, and Stiftelsen Åpen Dør are unavailable as real counterparties.</strong>{' '}
        The names are laboratory stand-ins. This ceremony is not a police power and not a finished legal basis.
      </Alert>
      <Row className="g-3">
        <Col lg={6}>
          <Card className="h-100">
            <Card.Body>
              <Card.Title as="h3" className="h5">What this drill does</Card.Title>
              <ul className="mb-0">
                <li>A mock registry signs the target, window, scope, and session public key.</li>
                <li>Two of three lab custodians re-encrypt period shares to that session key.</li>
                <li>The investigator workstation opens messages in the signed window. Family only if the order lists family. School rooms stay out.</li>
                <li>Other people in a thread are labelled Correspondent A, B, and so on. The words may still name them.</li>
                <li>Åpen Dør can attest or flag. It never holds a share.</li>
                <li>Expiry closes the session and destroys the workstation keys.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="h-100 access-unavailable-card">
            <Card.Body>
              <Card.Title as="h3" className="h5">Not this slice</Card.Title>
              <ul className="mb-0">
                <li>Real tingrett, BankID, or PST accounts.</li>
                <li>Investigator download of plaintext.</li>
                <li>School classmate or school-staff chat in the bundle. Those rooms are omitted; a shared key cannot strip a child’s words honestly.</li>
                <li>Dictionary search across the corpus.</li>
                <li>Any notice to the named adult or their recovery circle.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </section>
  );
}
